import React from 'react'
import Hero from '../components/Hero'
import GlobalHiring from '../components/GlobalHiring'
import { headings, StaffingEORservices } from '../data/GlobalHiringData'
import CardSection from '../components/CardSection'
import {  featureStaffingEorData_three } from '../data/CardSectionData'
import {  featuresStaffingEor_three } from '../data/CardData'
import TextwithImage from '../components/TextwithImage'
import { textSections } from '../data/TextwithimageData'
import HireSection from '../components/HireSection'
import { hiringsectionincompany } from '../data/HiresectionData'
import { useNavigate } from 'react-router-dom'
import StaffingEorTech from '../components/StaffingEorTech'
import DynamicClient from '../data/DynamicClient'

const StaffingEOR = () => {
  const navigate = useNavigate();
    const buttons = [
        { text: "Speak to an expert" , buttonClass: "companyFirstbutton"  }
      ];
  return (
    <>
    <Hero
      title="Employer of Record (EOR) Services for Recruitment Firms:"
      description="Managing employees across different regions can be complex with various laws and regulations. Our Employer of Record (EOR) services handle all the legal, payroll, and compliance tasks, allowing recruitment firms to focus on hiring the best talent with ease. Ampstekpay simplifies the process, ensuring smooth and efficient operations."
      buttonText="Connect with Expert"
      customClass="CompanyHiringBanner"
      imageSrc="images/hero.jpg"
      squareColor="CompanyHiringsquare-bg-color"
      onButtonClick={() => navigate('/meet-the-experts')}
    />
    <TextwithImage data={textSections.PageStaffingEor} />
    <CardSection data={featureStaffingEorData_three} featuress={featuresStaffingEor_three} customClass ='StaffingEorCard' />
    <GlobalHiring services={StaffingEORservices} customClass='StaffingEorservice' heading={headings.page3}/>
    
    
    <StaffingEorTech/>
    <TextwithImage data={textSections.PageStaffingEorList} />
    <DynamicClient customClass="homepageclient"/>
    <HireSection
        imageSrc={hiringsectionincompany.imageSrc}
        title={hiringsectionincompany.title}
        description={hiringsectionincompany.description}
        buttonText={buttons}
        className={hiringsectionincompany.className}
      />
    </>
  )
}

export default StaffingEOR